import Api from './Api';
import { ApiResponse } from 'apisauce';
import * as urls from '../components/shared/urls';
import { PrintRequest } from '../components/PrintPDF/common/defaults';
import { b64toBlob } from '../components/PrintPDF/common/utils';

export function redactedInvestigatorReport(url, id) {
  return new Promise<void>((resolve, reject) => {
    Api.get(url, { id: id, isRedacted: true })
      .then((response: ApiResponse<any>) => {
        //console.log('pdf response', response);
        if (response.data && response.data.length > 0) {
          let downloadWindow = window.open('');
          downloadWindow.window.document.title = 'Document';
          downloadWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
              encodeURI(response.data) +
              "'></iframe>"
          );
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        resolve();
      });
  });
}

export function sampleRedactedPdf(url) {
  return new Promise<void>((resolve, reject) => {
    Api.get(url)
        .then((response: any) => {
          if (response && response.data 
            && response.data.pdf && response.data.pdf.length > 0) {
              const file = b64toBlob(response.data.pdf, 'application/pdf');
              const fileURL = URL.createObjectURL(file);
              window.open(fileURL, '_blank', 'width=1000,height=800');
              window.focus();
            }
        })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        resolve();
      });
  });
}

export function form40(crashId, isRedacted) {
  var data;
  return new Promise<void>((resolve, reject) => {
    Api.get(urls.FORM_40, { id: crashId, isRedacted })
      .then((response: ApiResponse<any>) => {
        if (response.data) {
          data = response.data;
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        resolve(data);
      });
  });
}

export function paperReport(url, id) {
  return new Promise<void>((resolve, reject) => {
    Api.get(url, { id: id })
      .then((response: ApiResponse<any>) => {
        if (response.data && response.data.length > 0) {
          let downloadWindow = window.open('');
          downloadWindow.window.document.title = 'Document';
          downloadWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
              encodeURI(response.data) +
              "'></iframe>"
          );
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        resolve();
      });
  });
}

export function openOnBaseImage(crashId, docId) {
  var source;
  return new Promise<any>((resolve, reject) => {
    getOnBaseImage(crashId, docId)
      .then((data: any) => {
        if (data) {
          source = data.source;
          if (data.pdf && data.pdf.length > 0) {
            const file = b64toBlob(data.pdf, 'application/pdf');
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank', 'width=1000,height=800');
            window.focus();
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        resolve(source);
      });
  });
}

export function openLocalImage(crashId, docId) {
  var source;
  return new Promise<any>((resolve, reject) => {
    getLocalImage(crashId, docId)
      .then((data: any) => {
        if (data) {
          source = data.source;
          if (data.pdf && data.pdf.length > 0) {
            const file = b64toBlob(data.pdf, 'application/pdf');
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank', 'width=1000,height=800');
            window.focus();
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        resolve(source);
      });
  });
}

export function getOnBaseImage(crashId, docId) {
  var data;
  return new Promise<string>((resolve, reject) => {
    Api.get(urls.GET_ONBASE_IMAGE, {
      crashId: crashId,
      documentId: docId,
      isRedacted: false,
    })
      .then((response: ApiResponse<any>) => {
        if (response.data) {
          data = response.data;
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        resolve(data);
      });
  });
}

export function getLocalImage(crashId, docId) {
  var data;
  return new Promise<string>((resolve, reject) => {
    Api.get(urls.GET_LOCAL_IMAGE, {
      crashId: crashId,
      documentId: docId,
      isRedacted: false,
    })
      .then((response: ApiResponse<any>) => {
        if (response.data) {
          data = response.data;
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        resolve(data);
      });
  });
}

export function getPaperImageByKeywordsId(keywordsId) {
  var data;
  return new Promise<any>((resolve, reject) => {
    Api.get(urls.GET_PAPER_IMAGE, {
      keywordsId: keywordsId,
      isRedacted: false,
    })
      .then((response: ApiResponse<any>) => {
        if (response.data) {
          data = response.data;
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        resolve(data);
      });
  });
}

export function getPaperImageByReportId(reportId: number) {
  let data: string;
  return new Promise<string>((resolve, reject) => {
    Api.get(urls.GET_REPORT_IMAGE_BY_REPORT_ID, {
      reportId,
    })
      .then((response: ApiResponse<string>) => {
        if (response.data) {
          data = response.data;
        }
      })
      .catch(function (error) {
        console.log(error);
        reject(error);
      })
      .finally(function () {
        resolve(data);
      });
  });
}

export function getFrontSheet(reportId: number) {
  let data: string;
  return new Promise<string>((resolve, reject) => {
    Api.get(`${urls.GENERATE_FRONT_SHEET}?reportId=${reportId}`)
      .then((response: ApiResponse<string>) => {
        if (response.data && response.data.length > 0) {
          data = response.data;
          const file = b64toBlob(data, 'application/pdf');
          const fileUrl = URL.createObjectURL(file);

          const frontSheetWindow = window.open(
            fileUrl,
            '_blank',
            'width=1000,height=800'
          );
          frontSheetWindow.document.title = 'Front Sheet';
          frontSheetWindow.focus();
        }
      })
      .finally(() => resolve(data));
  });
}
